export const LCC_CONSTANTS = {
    // ----- Unit economics -----
    AVG_JOB_VALUE_GBP: 160,
    LEAD_TO_BOOKING_RATE: 0.30,
    DIRECT_COST_PCT: 0.33,
    LEADS_PER_BOOKING: 3.33,
    VAT_ACTIVE: false,
    VAT_RATE: 0.20,
    // ----- CPL traffic-light thresholds (GBP) -----
    CPL_GREEN_MAX: 8,
    CPL_YELLOW_MAX: 12,
    CPL_ORANGE_MAX: 15,
    CPL_RED_CEILING: 15,
    // ----- Capacity -----
    CAPACITY_JOBS_PER_WEEK: 40,
    CAPACITY_WARNING_PCT: 0.70,
    CAPACITY_CRITICAL_PCT: 0.90,
    // ----- Currency -----
    EUR_TO_GBP_FALLBACK: 0.87,
    // ----- Budget ramp gates -----
    BUDGET_BUMP_INCREASE_PCT: 0.30,
    BUDGET_CUT_DECREASE_PCT: 0.20,
    BUDGET_BUMP_MIN_DAYS_GREEN: 5,
    BUDGET_CUT_MIN_DAYS_ORANGE: 3,
    // ----- Scaling targets -----
    CURRENT_DAILY_BUDGET_GBP: 60,
    TARGET_DAILY_BUDGET_GBP: 220,
    // ----- Attribution -----
    LEAD_BOOKING_MATCH_WINDOW_DAYS: 30,
    CREATIVE_EVAL_WINDOW_DAYS: 14,
    // ----- Anomaly detection -----
    SPEND_SPIKE_THRESHOLD: 1.5,
    LEAD_DROUGHT_THRESHOLD: 0.5,
    CPL_SPIKE_THRESHOLD: 2.0,
    SYNC_STALE_MINUTES: 30,
    WEBHOOK_STALE_HOURS: 24,
};
//# sourceMappingURL=constants.js.map